document.getElementById("downloadInventoryData").addEventListener("click", function () {

  let clickedElement = this;  
  let totalProductsCount = Number(this.getAttribute("data-totalCount"));
  let fetchRequestsCount = Math.ceil(totalProductsCount / 48);

  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent += "Product Name,Variant Title,SKU,Metro Greensboro,Metro Eastvale,Ontario Warehouse,Next Shipment ETA\n"; // Updated CSV Headers
  this.textContent = "Started";
  this.disabled = true; 


  // Warning before page unload
  const beforeUnloadHandler = (e) => {
    e.preventDefault();
    e.returnValue = 'Download is in progress. Are you sure you want to leave?';
    return 'Download is in progress. Are you sure you want to leave?';
  };
  
  // Add the warning
  window.addEventListener('beforeunload', beforeUnloadHandler);
  function csvEscape(value) {
    if (value == null) return '""';
    const v = value.toString().replace(/"/g, '""');
    return `"${v.replace(/\r?\n/g, ' ')}"`; // keep it one line
  }
  async function fetchDataInSequence() {
  
    try {
      // Loop through all pages and collect data
      for(let i = 1; i <= fetchRequestsCount; i++) {
        console.log(`Fetching page ${i} of ${fetchRequestsCount}`);  
        let response = await fetch(`https://trade.tovfurniture.com//collections/all-products?page=${i}`);
        if (!response.ok) throw new Error(`HTTP ${response.status} on page ${i}`);
        let data = await response.text();
        let progress = Math.round((i/fetchRequestsCount) * 100);
        if(progress >= 100) {
          clickedElement.textContent = "Completed";
        }
        else {
          clickedElement.textContent = `In Progress (${progress}%)`;
        }        
        dataProcessing(data); // This will append to csvContent
        
      }
      
      // After all data is collected, create and download the CSV
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "inventory_data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up
      
    } 
    catch (error) {
      console.log("General error:", error);
      clickedElement.textContent = "Failed";

    } 
    finally {
      // Reset button text only after all operations complete
      // document.getElementById("downloadCSV").textContent = "Download";
      setTimeout(() => {        
        clickedElement.textContent = "Download";
        document.getElementById("downloadInventoryData").disabled = false; 
      }, 2000);
    }     
    
  }

  function dataProcessing(data) {    
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const gridItem = Array.from(doc.body.querySelectorAll("#product-grid .grid__item"));
    gridItem.forEach(function (item) {
      let productTitle = item.querySelector(".catalog-product-title").innerHTML;
      const variantDataWrapper = item.querySelectorAll(".catalog-variant-data-wrapper");
      variantDataWrapper.forEach(function (variant) {
        let variantTitle = variant.querySelector(".catalog-variant-title").innerHTML;
        let variantSku = variant.querySelector(".catalog-variant-sku").innerHTML;
        let variantMetroGreensboro = variant.querySelector(".catalog-variant-metro-greensboro").innerHTML;
        let variantMetroEastVale = variant.querySelector(".catalog-variant-metro-eastvale").innerHTML;
        let variantOntario = variant.querySelector(".catalog-variant-ontario").innerHTML;
        // let variantJamestownOffice = variant.querySelector(".catalog-variant-jamestown-office").innerHTML;
        let variantEta = variant.querySelector(".catalog-variant-eta").innerHTML;
        // csvContent += `${productTitle},${variantTitle},${variantSku},${variantMetroGreensboro},${variantMetroEastVale},${variantOntario},${variantJamestownOffice}\n`;
        csvContent += [productTitle,variantTitle,variantSku,variantMetroGreensboro,variantMetroEastVale,variantOntario,variantEta].map(csvEscape).join(',') + '\n';
      });
    });
  }
  fetchDataInSequence();
});